








import { barcodeFormatter } from "@/shared/barcodeFormatter";
import DefaultRevisionSheet from "@/components/DefaultRevisionSheet.vue";
import { createComponent } from "@vue/composition-api";
import ProductListUnitsTableDetail from "./ProductListUnitsTableDetail.vue";

export default createComponent({
  components: {
    DefaultRevisionSheet,
    ProductListUnitsTableDetail,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  setup(prosp, ctx) {
    return {};
  },
});
